import customEventDirective from './custom-event.directive';

const ceAdaperModule = angular.module('customEventAdapter', []);

ceAdaperModule.directive('customEvent', customEventDirective);

export default ceAdaperModule;
